export enum KEYCLOAK_CLIENT_ID {
  GUEST_JOURNEY = "sv-magic-guest-journey",
  PLATFORM = "sv-magic-platform",
  BACKOFFICE = "sv-magic-backoffice"
}
